import moment from "moment";
window.moment = moment;
export const createMonthList = vdate => {
  const date = moment(vdate);
  const nextMonth = date.clone().add(1, "month"); // den ngày này
  return [date, nextMonth];
};

export const renderCalendar = vdate => {
  const date = moment(vdate);
  const days = [];
  // const startWeek = date.startOf('month').isoWeek();
  // let endWeek = date.endOf('month').isoWeek();
  // if (startWeek === 48) {
  //   endWeek = 53;
  // }
  // if (startWeek === 1) {
  //   // startWeek = 1;
  //   endWeek = 6;
  // }
  // for (var week = startWeek; week <= endWeek; week++) {
  //   const daysInWeek = renderDaysInWeek(week);
  //   days = [...days, ...daysInWeek];
  // }
  const firstDate = date
    .clone()
    .startOf("month")
    .startOf("week");
  const lastDate = date
    .clone()
    .endOf("month")
    .endOf("week");
  const length = lastDate.diff(firstDate, "days") + 1;
  for (let i = 0; i < length; i++) {
    days.push(firstDate.clone().add(i, "day"));
  }
  return days;
};

export const renderDaysInWeek = week => {
  return Array(7)
    .fill(0)
    .map((n, i) => {
      return moment()
        .week(week)
        .startOf("week")
        .clone()
        .add(n + i, "day");
    });
};
